<template>
  <div id="theme-song" class="section theme_song columns is-gapless is-mobile is-centered">
    <div class="section--main--holder column is-12-mobile is-8-desktop is-large-6">
      <section class="section--main">
        <h2 class="section--title centered">
          <img src="/static/img/titles/Theme-song.png" alt="Theme song">
          <strong class="seo">Theme song</strong>
        </h2>

        <article class="song_article">
          <h3 class="song_article--title">DEN「光」</h3>

          <p class="song_article--main">谷本賢一郎（Gt,Vo）×道尾秀介（Gt,Vo）による音楽ユニット。「DEN」は「（子供たちの）秘密の遊び場」の意味を持つ。2018年、初ワンマンライブ、初アルバムリリース予定。</p>

          <a href="http://michioshusuke.com/" class="song_article--link" title="" target="_blank">道尾秀介 Official Website></a>
          <a href="http://maimusic.net/" class="song_article--link" title="" target="_blank">谷本賢一郎 Official Website></a>
        </article>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'theme-song',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Themesong.vue